<template lang="pug">
	section.section.main-section
		.container
			title-comp(:name="$t('title.signup')")
			.form-container.form-login
				p.has-text-centered.margin-bottom-md
					| {{ $t('signup.required_fields') }}

				.field(v-if="userPromoCode")
					p.has-text-centered
						strong {{ $t('signup.promo_code').toUpperCase() }}
				.field(v-if="userPromoCode")
					p.control.has-icons-left
						input.input(type="text" disabled v-model="userPromoCode")
						span.icon.is-small.is-left
							gift-icon(size="1.5x")

				.field.margin-top-md(v-if="userPromoCode")
					p.has-text-centered
						strong {{ $t('signup.profile').toUpperCase() }}
				.field(v-else)
					p.has-text-centered
						strong {{ $t('signup.profile').toUpperCase() }}
				.field
					p.control
						input.input(type="text" :placeholder="$t('placeholder.nickname')" v-model="nickname")

				.field
					p.control
						input.input(type="text" :placeholder="$t('placeholder.name')" v-model="first_name")

				.field
					p.control
						input.input(type="text" :placeholder="$t('placeholder.surname')" v-model="last_name")

				.field.margin-top-md
					p.has-text-centered
						strong {{ $t('signup.credentials').toUpperCase() }}

				.field
					p.control.has-icons-left
						input.input(type="email" :placeholder="$t('placeholder.email')" v-model="email" required)
						span.icon.is-small.is-left
							mail-icon(size="1.5x")

				.field.has-addons
					p.control.has-icons-left.is-expanded
						input.input(:type="hidden ? 'password' : 'text'" :placeholder="$t('placeholder.password')" v-model="password" required)
						span.icon.is-small.is-left
							lock-icon(size="1.5x")
					p.control
						a.button(@click="toggleHidden")
							eye-icon(size="1.5x" v-if="hidden")
							eye-off-icon(size="1.5x" v-else)

				.field.has-addons
					p.control.has-icons-left.is-expanded
						input.input(:type="hidden ? 'password' : 'text'" :placeholder="$t('placeholder.password_confirm')" v-model="password_confirm")
						span.icon.is-small.is-left
							lock-icon(size="1.5x")
					p.control
						a.button(@click="toggleHidden")
							eye-icon(size="1.5x" v-if="hidden")
							eye-off-icon(size="1.5x" v-else)

				.field.margin-top-md
					label.checkbox
						input(type='checkbox' v-model="privacy1" required)
						| {{ $t('form.agree_tos_privacy1') }}
						a(href="/terms" target="_blank") {{ $t('menu.terms') }}
						| {{ $t('form.agree_tos_privacy2') }}
						a(href="/warnings" target="_blank") {{ $t('menu.warnings') }}
						| {{ $t('form.agree_tos_privacy3') }}
						a(href="/privacy" target="_blank") {{ $t('menu.privacy') + '.' }}

				.field
					label.checkbox
						input(type='checkbox' v-model="privacy3" required)
						| {{ $t('form.agree_privacy3') }}
						a(href="/privacy" target="_blank") {{ $t('menu.privacy') }}
						| ).

				.field
					label.checkbox
						input(type='checkbox' v-model="privacy2" required)
						| {{ $t('form.agree_privacy2') }}
						a(href="/privacy" target="_blank") {{ $t('menu.privacy') }}
						| ).

				.field.margin-top-md
					p.control.has-text-centered
						button.button.is-primary(type="button" v-bind:class="buttonClass" @click="submitSignup")
							| {{ $t('button.continue') }}

				article.message.is-danger(v-if="errorNickname" transition="fade")
					.message-body
						| {{ $t('alert.missing_nickname') }}
				article.message.is-danger(v-else-if="errorName" transition="fade")
					.message-body
						| {{ $t('alert.missing_name_surname') }}
				article.message.is-danger(v-else-if="errorEmail" transition="fade")
					.message-body
						| {{ $t('alert.missing_email') }}
				article.message.is-danger(v-else-if="insicurePassword" transition="fade")
					.message-body
						| {{ $t('alert.insicure_password') }}
				article.message.is-danger(v-else-if="errorPassword" transition="fade")
					.message-body
						| {{ $t('alert.missing_password') }}
				article.message.is-danger(v-else-if="errorPasswordConfirm" transition="fade")
					.message-body
						| {{ $t('alert.missing_password_confirm') }}
				article.message.is-danger(v-else-if="errorPasswordMismatch" transition="fade")
					.message-body
						| {{ $t('alert.missing_password_mismatch') }}
				article.message.is-danger(v-else-if="errorPrivacy" transition="fade")
					.message-body
						| {{ $t('alert.missing_privacy') }}
				article.message.is-danger(v-else-if="errorAuth" transition="fade")
					.message-body
						| {{ $t('alert.invalid_login') }}
				article.message.is-danger(v-else-if="duplicateAuth" transition="fade")
					.message-body
						| {{ $t('alert.duplicate_email') }}

</template>

<script>
import TitleComponent from '../components/TitleComponent.vue'
import { MailIcon, KeyIcon, BriefcaseIcon, LockIcon, EyeOffIcon, EyeIcon, GiftIcon } from 'vue-feather-icons'

export default {
	components: {
		TitleComp: TitleComponent,
		MailIcon,
		LockIcon,
		BriefcaseIcon,
		KeyIcon,
		EyeOffIcon,
		EyeIcon,
		GiftIcon
	},
	data() {
		return {
			nickname             : '',
			first_name           : '',
			last_name            : '',
			email                : '',
			password             : '',
			password_confirm     : '',
			privacy              : false,
			privacy1             : false,
			privacy2             : false,
			privacy3             : false,
			hidden               : true,
			errorNickname        : false,
			errorName            : false,
			errorEmail           : false,
			insicurePassword     : false,
			errorPassword        : false,
			errorPasswordConfirm : false,
			errorPasswordMismatch: false,
			errorPrivacy         : false,
			errorPage            : false,
			errorAuth            : false,
			duplicateAuth        : false
		}
	},
	props: {
		embedded: Boolean,
		showing : Boolean
	},
	computed: {
		accessToken() {
			return this.$store.state.auth.accessToken
		},
		signupToken() {
			return this.$store.state.auth.signupToken
		},
		userPromoCode() {
			return this.$store.state.user.userPromoCode
		},
		companyCode() {
			return this.$store.state.auth.companyCode
		},
		loading() {
			return this.$store.state.auth.loading
		},
		buttonClass() {
			return { 'is-loading': this.loading }
		}
	},
	mounted() {
		this.$meta().setOptions({ title: this.$t("title.signup") + ' | ' + this.$t("title.home") })
		if (this.accessToken) {
			this.$router.replace('/')
		}

		//request signup token
		this.$store.dispatch('auth/getSignupToken')
	},
	methods: {
		toggleHidden() {
			this.hidden = !this.hidden
		},
		submitSignup() {
			if (!this.nickname) {
				this.errorNickname = true
				return
			}
			if (!this.first_name || !this.last_name) {
				this.errorName = true
				return
			}
			if (!this.email || this.email.indexOf('@') === -1 || this.email.indexOf('.') === -1) {
				this.errorEmail = true
				return
			}
			if (!this.password) {
				this.errorPassword = true
				return
			}

			if (!this.password.match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{7,}$/)) {
				this.insicurePassword = true
				return
			}

			if (!this.password_confirm) {
				this.errorPasswordConfirm = true
				return
			}
			if (this.password_confirm !== this.password) {
				this.errorPasswordMismatch = true
				return
			}

			if (!this.privacy1) {
				this.errorPrivacy = true
				return
			}

			this.hidden = true
			this.$store.dispatch('auth/verifyEmail', {
				email   : this.email,
				password: this.password
			})
				.then(response => {
					return this.$store.dispatch('auth/submitSignup', {
						nickname  : this.nickname,
						first_name: this.first_name,
						last_name : this.last_name,
						email     : this.email,
						password  : this.password,
						privacy   : {
							'privacy'   : this.privacy1,
							'newsletter': this.privacy1,
							'profiling' : this.privacy3,
							'thirdparty': this.privacy2
						}
					})
				})
				.then(response => {
					if (response) {
						this.first_name = ''
						this.last_name = ''
						this.email = ''
						this.password = ''
						this.password_confirm = ''
						this.$router.replace('/signup-confirm')
					}
				})
				.catch(err => {
					if (err.response && err.response.status) {
						switch (err.response.status) {
							case 409:
								this.duplicateAuth = true
								break
							case 403:
								this.errorAuth = true
								break
							case 500:
								this.errorPage = true
								break
							default:
								console.warn(err.response.status)
						}
					}
				})
		}
	},
	watch: {
		nickname() {
			this.errorNickname = false
		},
		first_name() {
			this.errorName = false
		},
		last_name() {
			this.errorName = false
		},
		email() {
			this.errorEmail = false
			this.duplicateAuth = false
		},
		password() {
			this.errorPassword = false
			this.errorPasswordMismatch = false
			this.insicurePassword = false
		},
		password_confirm() {
			this.errorPasswordConfirm = false
			this.errorPasswordMismatch = false
			this.insicurePassword = false
		},
		privacy() {
			this.errorPrivacy = false
		},
		privacy1() {
			this.errorPrivacy = false
		}
	}
}
</script>
